<template>
  <div class="form-group color-group position-relative">
    <label class="font-size-12">{{ label }}</label>
    <div class="position-relative">
      <input v-model="iValue" type="text" class="form-control" :style="{ paddingLeft: '34px' }" />
      <span
        :style="{
          backgroundColor: iValue,
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.15)',
          top: '10px',
          left: '10px'
        }"
        class="color-preview position-absolute cursor-pointer"
        @click="showModal"
      />
    </div>
    <div v-if="isShow" class="position-relative">
      <ColorPickerModalNew v-model="iValue" @closed="closedColorModal" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ColorPickerModalNew: () => import('./ColorPickerModalNew.vue')
  },
  props: {
    value: { required: false, type: [String], default: '' },
    label: { required: false, type: [String], default: '' }
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newVal) {
        this.$emit('input', newVal)
        this.$emit('change', this)
      }
    }
  },
  methods: {
    showModal() { this.isShow = true },
    closedColorModal() { this.isShow = false }
  }
}
</script>